var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[('text' in _vm.columnData)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.columnData.text)}}):_vm._e(),(!'hide_empty' in _vm.columnData || !_vm.columnData.hide_empty || !!_vm.columnData.caption)?_c('a',{staticClass:"link",on:{"click":_vm.emitAction}},[_vm._v(" "+_vm._s(_vm.columnData.caption)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }